export default "__VITE_PUBLIC_ASSET__1108fdc9__"